/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_kleber__reststop__description1 = /** @type {(inputs: {}) => string} */ () => {
	return `empfiehlt diesen Bereich für Familien`
};

const en_kleber__reststop__description1 = /** @type {(inputs: {}) => string} */ () => {
	return `recommends this area for families`
};

const es_kleber__reststop__description1 = /** @type {(inputs: {}) => string} */ () => {
	return `recomienda esta zona para familias`
};

const fr_kleber__reststop__description1 = /** @type {(inputs: {}) => string} */ () => {
	return `recommande cette aire pour les familles`
};

const it_kleber__reststop__description1 = /** @type {(inputs: {}) => string} */ () => {
	return `raccomanda questa zona per le famiglie`
};

const nl_kleber__reststop__description1 = /** @type {(inputs: {}) => string} */ () => {
	return `raadt dit gebied aan voor gezinnen`
};

const pt_kleber__reststop__description1 = /** @type {(inputs: {}) => string} */ () => {
	return `recomenda esta zona para famílias`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const kleber__reststop__description1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.kleber__reststop__description1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("kleber__reststop__description1", locale)
	if (locale === "de") return de_kleber__reststop__description1(inputs)
	if (locale === "en") return en_kleber__reststop__description1(inputs)
	if (locale === "es") return es_kleber__reststop__description1(inputs)
	if (locale === "fr") return fr_kleber__reststop__description1(inputs)
	if (locale === "it") return it_kleber__reststop__description1(inputs)
	if (locale === "nl") return nl_kleber__reststop__description1(inputs)
	return pt_kleber__reststop__description1(inputs)
};
export { kleber__reststop__description1 as "kleber__restStop__description" }